const getIsTouchDevice = () => {

    if(typeof window?.matchMedia !== 'function') {

        return false;

    }

    return window.matchMedia('(pointer: coarse)').matches && !window.matchMedia('(pointer: fine)').matches;

};

export default getIsTouchDevice;
